var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-alert',{staticClass:"rounded-xl",attrs:{"type":"warning","icon":"mdi-account-hard-hat","id":"debug-alert","dense":"","dismissible":""}},[_vm._v(" DEBUG BUILD ")])
}
var staticRenderFns = []

export { render, staticRenderFns }